@if (activityService.showGuestFields) {
  <app-activities-lite-guest-data [checkedNonDiningLocalTime]="checkedNonDiningLocalTime" [checkedDiningLocalTime]="checkedDiningLocalTime"
    [TimeSlotUnitInMinutes]="TimeSlotUnitInMinutes" [matchedContinousSlots]="matchedContinousSlots"
    [selectedActivity]="selectedActivityData" [customGuestFields]="customGuestFields"
    [editContactData]="editContactData" [stayGuestList]="stayGuestDetails" [notesOptions]="notesOptions" [promoCodeDetail]="promoCodeDetail" [noteType]="noteType"
  (guestData)="setGuestData($event)" (notesData)="setNotesData($event)"></app-activities-lite-guest-data>
}
@if (!activityService.showGuestFields) {
  <div class="page-title-section px-3 row m-0 pt-5 pb-4 flex-column" id="pageTitle">
    <div class="main-title main-theme-color d-flex text-uppercase justify-content-center text-center text-uppercase">
      {{!activityService.isDining ? ((activityService.isNonDining && !activityService?.toListOpenActitivitiesList) ? activityService.selectedNonDining.RestaurantName :
      (selectedActivityData?.Name || activityService?.selectedSpecialMeal?.Name)) : activityService.selectedDining.RestaurantName}}
    </div>
    @if (activityService.isDining && activityService.selectedDining.WidgetCustomization?.DisplayRestaurantAddress) {
      <div
        >
        <div
          class="pt-3 dining-location text-uppercase activity-title class-info__detail__location d-flex align-items-center justify-content-center text-center">
          <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
          &nbsp; {{activityService.selectedDining.Street1}}{{activityService.selectedDining.Street2}},
          {{activityService.selectedDining.City}}, {{activityService.selectedDining.Country}}
        </div>
      </div>
    }
    @if (activityService.isNonDining) {
      <div>
        <div
          class="pt-3 dining-location text-uppercase activity-title class-info__detail__location d-flex align-items-center justify-content-center text-center ">
          <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
          &nbsp; {{activityService.selectedNonDining.Street1}}{{activityService.selectedNonDining.Street2}},
          {{activityService.selectedNonDining.City}}, {{activityService.selectedNonDining.Country}}
        </div>
      </div>
    }
    <div class="mt-3 sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">
      {{(activityService.selectedDining.WidgetCustomization?.HeaderText ?
      activityService.selectedDining.WidgetCustomization?.HeaderText : 'selectYourDesiredSlot') | translate}}
    </div>
  </div>
  <div class="container">
    @if (!isEdit && activityService.isDining && !activityService.selectedDining.WidgetCustomization?.AllowNewReservations && availableSpecialMeals.length > 0) {
      <div
        >
        <div class="col-12 d-flex flex-row justify-content-center align-items-center tab-view">
          <div matRipple matRippleCentered="true"
            class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu"
            (click)="specialMealReservation()"
            [ngClass]="showSpecialEvent ? 'sub-menu-selection' : 'sub-menu-unselected'">
            <div class="d-flex align-items-center">&nbsp;{{'specialEvent' | translate}}</div>
          </div>
          <div matRipple matRippleCentered="true"
            class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu"
            (click)="normalTableReservation(false, activityService.selectedDining?.MaxPartySize)"
            [ngClass]="!showSpecialEvent ? 'sub-menu-selection' : 'sub-menu-unselected'">
            <div class="d-flex align-items-center">&nbsp;{{'tableReservation' | translate}}</div>
          </div>
        </div>
      </div>
    }
    @if (activityService.isDining && activityService.selectedDining.WidgetCustomization?.SubHeaderText) {
      <div
        class="p-3 col-12 dining-main-title mt-4 mb-2 activity-description-bolder activity-description-dining text-uppercase">
        {{(activityService.selectedDining.WidgetCustomization?.SubHeaderText ?
        activityService.selectedDining.WidgetCustomization?.SubHeaderText : 'letsMakeReservation') | translate }}
      </div>
    }
    @if (activityService.isNonDining) {
      <div
        class="p-3 col-12 dining-main-title mt-4 mb-2 activity-description-bolder text-uppercase">
        {{(activityService.selectedDining.WidgetCustomization?.SubHeaderText ?
        activityService.selectedDining.WidgetCustomization?.SubHeaderText : 'letsMakeReservation') | translate }}
      </div>
    }
    @if (activityService.isDining && showSpecialEvent && availableSpecialMeals.length > 0 && !activityService?.mealWithConfig) {
      <div
        class="px-2 col-12 d-flex justify-content-end">
        <div class="activity-description d-flex align-items-center">
          <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"></span> &nbsp;{{'prePaymentNeeded' | translate}}
        </div>
      </div>
    }
    @if (activityService.mealWithConfig && activityService.isDining) {
      <div class="selected-meal-view">
        @if (this.activityService.mealWithConfig?.ImageUrl) {
          <img class="meal-image" [src]="this.activityService.mealWithConfig?.ImageUrl" alt="meal-image">
        }
        <div class="meal-container">
          <div class="meal-header">
            <div><span class="meal-name">{{this.activityService.mealWithConfig?.Name || ''}}</span>
            <span class="meal-size" >&nbsp;({{'serves'| translate}} {{this.activityService.mealWithConfig?.MinPartySize}} -
            {{this.activityService.mealWithConfig?.MaxPartySize}})</span>
          </div>
          @if (this.activityService.mealWithConfig?.DoesRequirePrepayment) {
            <div
              class="d-flex special-meal-payment-required align-items-center font-weight-bold ">
              <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"></span>&nbsp;{{'prePaymentNeeded' | translate}}
            </div>
          }
        </div>
        @if (activityService.mealWithConfig?.CoverTypePrices.length == 0 && this.activityService.mealWithConfig?.Price) {
          <div >
            <span class="meal-price">{{this.activityService.mealWithConfig?.OperationCurrency + ' ' + (this.activityService.mealWithConfig?.Price | currencyDecimalFormatter)}}</span>
          </div>
        }
        @if (activityService.mealWithConfig?.CoverTypePrices.length > 0) {
          <div
            class="d-flex cursor-pointer activity-description activity-list-title disable-text-select">
            <span (click)="$event.stopPropagation()" placement="bottom" [ngbPopover]="popContent">{{'viewPricing'
            | translate}}</span>
          </div>
        }
        <ng-template #popContent>
          @for (coverPrice of activityService.mealWithConfig?.CoverTypePrices; track coverPrice) {
            <div class="price-popover activity-description-bolder"
              >
              {{coverPrice.CoverTypeName + ' - ' +
              activityService.mealWithConfig.OperationCurrency + ' ' + (coverPrice.Price | currencyDecimalFormatter)}}
            </div>
          }
        </ng-template>
        @if (this.activityService.mealWithConfig?.Description) {
          <p [innerHTML]="this.activityService.mealWithConfig?.Description | safeHtml">
          </p>
        }
      </div>
    </div>
  }
  @if (activityService.isDining && showSpecialEvent && availableSpecialMeals.length > 0 && !this.activityService.mealWithConfig) {
    <div>
      <div class="col-12">
        <div class="py-2 d-flex flex-wrap justify-content-center">
          @for (specialMeal of availableSpecialMeals; track specialMeal; let i = $index) {
            <div class="p-2 col-xl-3 col-md-4 col-12" (click)="selectSpecialMeal(i , true)">
              <div class="special-meal-container p-2 d- flex flex-column align-items-center"
                [ngClass]="{'special-meal-selected': specialMeal.Id === selectedActivityData?.Id}">
                <div class="d-flex justify-content-center position-relative">
                  <div class="text-uppercase text-truncate activity-title text-center">{{specialMeal?.Name}}
                  </div>
                  @if (specialMeal?.DoesRequirePrepayment) {
                    <div
                      class="d-flex special-meal-payment-required align-items-center position-absolute">
                      <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"></span>
                    </div>
                  }
                </div>
                <div class="activity-description text-center">{{('serves' | translate) + ' ' + specialMeal?.MinPartySize
                  + ' - ' +
                specialMeal?.MaxPartySize + ' ' + ('people' | translate)}}</div>
                @if (specialMeal?.CoverTypePrices.length > 0) {
                  <div
                    class="d-flex justify-content-center activity-description activity-list-title disable-text-select">
                    <span (click)="$event.stopPropagation()" placement="bottom" [ngbPopover]="specialMealPopContent">{{'viewPricing'
                    | translate}}</span>
                  </div>
                }
                @if (specialMeal?.CoverTypePrices.length === 0 && specialMeal?.Price) {
                  <div
                    class="dining-starting-price activity-description disable-text-select text-center">{{
                  selectedActivityData.OperationCurrency + ' ' + (specialMeal?.Price | currencyDecimalFormatter)}}</div>
                }
                <ng-template #specialMealPopContent>
                  @for (coverPrice of specialMeal?.CoverTypePrices; track coverPrice) {
                    <div class="price-popover activity-description-bolder"
                      >
                      {{coverPrice.CoverTypeName + ' - ' +
                      selectedActivityData.OperationCurrency + ' ' + (coverPrice.Price | currencyDecimalFormatter)}}
                    </div>
                  }
                </ng-template>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (!activityService.isDining && !activityService.isNonDining) {
    <div class="row">
      <div class="session-filter-portion mt-4 col-lg-3 col-md-12 col-sm-12 col-12 d-flex flex-column">
        <ng-container  *ngTemplateOutlet="bookingTypeFilter"></ng-container>
        @if (selectedActivityData?.AllowInstructorSelectionForActivity) {
          <mat-form-field appearance="outline">
            <mat-select placeholder="{{'SelectaInstructor' | translate}}" [value]="0" [(ngModel)]="currentInstructors">
              @for (eacInstructor of instructorList; track eacInstructor) {
                <mat-option [value]="eacInstructor.id">
                {{eacInstructor.value}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (activityService?.ConfigSettings?.AllowLocationSelectionForActivity) {
          <mat-form-field appearance="outline">
            <mat-select [value]="0" placeholder="{{'SelectaLocation' | translate}}" [(ngModel)]="currentLocations"
              (onSelectionChange)="checkSessionorSlotAvailability(false, true)">
              @for (eacLoc of locationList; track eacLoc) {
                <mat-option [value]="eacLoc.id">{{eacLoc.value}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="outline">
          <mat-label>{{(isMultiSlotSelection ? 'FromDate' : 'selectDate') | translate}}</mat-label>
          <input matInput placeholder="{{(isMultiSlotSelection ? 'FromDate' : 'selectDate') | translate}}" readonly
            [max]="bookingTypeMaxDate ? bookingTypeMaxDate  : (!activityService.isDining ? selectedActivityData?.EndDate : diningMaxDate)"
            [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
            (dateChange)="changeFromDate();checkSessionorSlotAvailability(false, true)" [disabled]="disableDatePicker">
            <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
            </mat-datepicker-toggle>
            <mat-datepicker #frompicker></mat-datepicker>
          </mat-form-field>
          @if (isMultiSlotSelection) {
            <mat-form-field appearance="outline">
              <mat-label>{{'ToDate' | translate}}</mat-label>
              <input matInput placeholder="{{'ToDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : selectedActivityData?.EndDate"
                [min]="bookingTypeMinDate ? bookingTypeMinDate : currentFromDate" [matDatepicker]="topicker" [(ngModel)]="currentToDate"
                (dateChange)="checkSessionorSlotAvailability(false, true)">
                <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="topicker">
                </mat-datepicker-toggle>
                <mat-datepicker #topicker></mat-datepicker>
              </mat-form-field>
            }
            @if (!activityService.isDining) {
              <size-mapping [coverTypes]="coverTypes" [bookingTypes]="bookingTypes" [minSize]="minSizeAllowed" [maxSize]="maxSizeAllowed" [(size)]="sizeMapping" (sizeChange)="bookingSizeChange()" [dataCovers]="selectedActivityData?.CoverTypeQuantities || []" [dataSize]="currentBookingSize" [isEdit]="isEdit"></size-mapping>
            }
            <!-- <ng-container @if (!activityService.isDining && bookingTypes?.length ===0 && coverTypes?.length ===0) {
            <mat-form-field appearance="outline">
              <mat-label>{{'SelectCoverSize' | translate}}</mat-label>
              <mat-select [(ngModel)]="currentBookingSize" name="genericCoverSize"
                placeholder="{{'SelectCoverSize' | translate}}"
                (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                <mat-option [value]="0">{{'0' | translate}}</mat-option>
                <mat-option [value]="bookingSize.id" @for (bookingSize of bookingSizeArray; track bookingSize) {>{{bookingSize.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container @for (bookType of bookingTypes; track bookType; let i = $index) {
            <mat-form-field appearance="outline">
              <mat-label>{{bookType.name}}</mat-label>
              <input type="text" [(ngModel)]="bookType.value" name="bookType_{{i}}" placeholder="{{bookType.name}}"
                (ngModelChange)="checkSessionorSlotAvailability(false, true)" matInput [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  <mat-option [value]="0">{{'0' | translate}}</mat-option>
                  <mat-option [value]="bookingSize.id" @for (bookingSize of bookingSizeArray; track bookingSize) {>
                    {{bookingSize.value}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </ng-container>
            <ng-container @for (cover of coverTypes; track cover; let i = $index) {
              <mat-form-field appearance="outline">
                <mat-label>{{cover.name}}</mat-label>
                <input type="number" [(ngModel)]="cover.value" name="cover_{{i}}" placeholder="{{cover.name}}"
                  (ngModelChange)="checkSessionorSlotAvailability(false, true)" matInput [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option [value]="0">{{'0' | translate}}</mat-option>
                    <mat-option [value]="bookingSize.id" @for (bookingSize of bookingSizeArray; track bookingSize) {>
                      {{bookingSize.value}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </ng-container> } -->
              <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
            </div>
            @for (sessionDates of sessionSlotsAvailableDates; track sessionDates; let i = $index) {
              @if (selectedIndex === i) {
                <div class="col-lg-9 col-md-12 col-sm-12 col-12">
                  <div class="activity-date-tab mt-4 p-3 d-flex activity-description-bolder justify-content-around">
                    @if (sessionSlotsAvailableDates.length > 1) {
                      <div class="select-prev-date" [class.disabledArrow]="i === 0"
                      (click)="loadPreviousDate(i)">&#60; </div>
                    }
                    <div class="selected-date">{{sessionDates.AvailableDate | localizeDate : 'DD MMMM, ddd'}}</div>
                    @if (sessionSlotsAvailableDates.length > 1) {
                      <div class="select-next-date" (click)="loadNextDate(i)"
                      [class.disabledArrow]="i === (sessionSlotsAvailableDates.length-1)">&#62;</div>
                    }
                  </div>
                  <div class="activity-date-slots mt-2 py-2 slots-view">
                    @for (eachSlot of sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions; track eachSlot; let i = $index) {
                      @if (!eachSlot.pastSlot) {
                        <div class="p-2 "
                          [class.slot-disabled]="eachSlot.disabled || eachSlot.disabledOverlaped || !eachSlot.isAddonAvailable">
                          <div (click)="slotChangeListners(eachSlot);"
                            class="activity-time-slot p-2 d-flex flex-column align-items-center position-relative"
                            [ngClass]="{'activity-time-slot-selected': eachSlot.isChecked === true}">
                            <!-- Session with count - Disabled for future requirement @if (false) -->
                            @if (false) {
                              <div class="session-slot__session-name" title="{{'Session' | translate}} {{i+1}}">
                              {{'session' | translate}} {{i+1}}</div>
                            }
                            <!-- Session with count - Disabled for future requirement @if (false) -->
                            @if (false) {
                              <div class="session-number activity-description">
                              {{eachSlot.SessionGroupName}}</div>
                            }
                            <div class="time-duration activity-description-bold">{{eachSlot.Start | localizeDate: 'LT'}}
                              @if (false) {
                                <span> - {{eachSlot.End | localizeDate: 'LT'}}</span>
                              }
                            </div>
                  <div [class.slot-disabled]="eachSlot.disabled || eachSlot.disabledOverlaped" [ngClass]="eachSlot.showAvailibility.status === 0 || eachSlot.showAvailibility.status === 2 ? 'count-left-more' :
                                                  eachSlot.showAvailibility.status === 1 ? 'count-left-limited' :
                                                  eachSlot.showAvailibility.status === 2 || eachSlot.showAvailibility.status === 3 
                                                  || eachSlot.showAvailibility.status === 5 ? 'count-left-less' : ''"
                              class="activity-description-bold">
                            {{eachSlot.showAvailibility.text}}</div>
                            @if (eachSlot.sessionHeadlines) {
                              <div class="activity-notes">
                                <i class="icon-info-with-circle"></i>
                                <span [matTooltip]="eachSlot.sessionHeadlines">{{ eachSlot.sessionHeadlines }}</span>
                              </div>
                            }
                            @if (eachSlot.isChecked) {
                              <div class="position-absolute slot-selected-container">
                                <mat-icon class="mat-icon-color session-select-mat-icon">check_circle</mat-icon>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    }
                  </div>
                  <div class="activity-date-slots mt-2 p-2 align-items-center slots-view">
                    @if (isMultiSlotSelection && isSessionClass
                      && sessionSlotsAvailableDates?.length
                      && sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions
                      && sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions?.length) {
                      <mat-checkbox
                        (change)="applyToOtherDates(selectedIndex, $event)" [checked]="bookAllAvailableDates">
                        <span class="px-3 activity-description-bold">
                          {{'Bookforallavailabledates' | translate}} (
                          <span class="date-text">
                            {{sessionSlotsAvailableDates[0]?.AvailableDate | localizeDate: 'DD MMMM'}} -
                            {{sessionSlotsAvailableDates[sessionSlotsAvailableDates.length -1].AvailableDate | localizeDate: 'DD
                            MMMM'}}
                          </span>
                          )
                        </span>
                      </mat-checkbox>
                    }
                  </div>
                </div>
              }
            }
            @if (!activityService.isDining && !activityService.loaderRunning && (!sessionSlotsAvailableDates || sessionSlotsAvailableDates?.length === 0) && ((isSessionClass
              && (!sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions
              || (sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions
              && sessionSlotsAvailableDates[selectedIndex]?.AvailableSessions.length === 0)))
              || (!isSessionClass && (!classLessonList || (classLessonList?.length === 0))))) {
              <div
                class="col-lg-9 col-md-12 col-sm-12 col-12 no-slots-message activity-no-data-error activity-description-bolder d-flex justify-content-center align-items-center"
                >
                {{'noSlotsAvailable' | translate}}
              </div>
            }
          </div>
        }
        @if (activityService.isDining) {
          <div class="row">
            <div class="col-12 mt-4 d-flex flex-wrap">
              <div class="col-lg-4 col-md-12 d-flex flex-column">
                <ng-container  *ngTemplateOutlet="bookingTypeFilter"></ng-container>
                <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                  <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                    (click)="changeDiningDate('prev')"
                  [class.disabledArrow]="currentFromDate <= activityService.currentDateTime">&#60;</div>
                  <div class="d-flex flex-column">
                    <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                    {{'selectDate' | translate}}</div>
                    <div class="cursor dining-selected-data activity-description text-center select-date-text-decoration"
                      (click)="frompicker.open()">
                    {{currentFromDate | localizeDate : 'DD MMMM, ddd'}}</div>
                    <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                      <mat-label>{{'selectDate' | translate}}</mat-label>
                      <input matInput placeholder="{{'selectDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : diningMaxDate"
                        (dateChange)="changeFromDate();checkSessionorSlotAvailability(false, true)"
                        [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
                        [matDatepickerFilter]="showParticularDays" [disabled]="disableDatePicker">
                        <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #frompicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                      (click)="changeDiningDate('next')"
                    [class.disabledArrow]="currentFromDate >= diningMaxDate || !(bookingTypeMaxDate | dateCompareByDay: currentFromDate) || !showNextArrow">&#62;</div>
                  </div>
                  @for (cover of coverTypes; track cover; let i = $index) {
                    <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                      <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                      (click)="changeCoverTypeSize('prev', i)" [class.disabledArrow]="cover.value === 0">&#45;</div>
                      <div class="d-flex flex-column">
                        <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                        {{cover.name}}</div>
                        <div class="cursor dining-selected-data activity-description text-center"
                          (click)="coverTypeSelect.open()">
                        {{cover.value}}</div>
                        <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                          <mat-label>{{cover.name}}</mat-label>
                          <mat-select [(ngModel)]="cover.value" #coverTypeSelect
                            (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                            <mat-option [value]="0">{{'0' | translate}}</mat-option>
                            @for (bookingSize of bookingSizeArray; track bookingSize) {
                              <mat-option [value]="bookingSize.id">
                                {{bookingSize.value}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                        (click)="changeCoverTypeSize('next', i)" [class.disabledArrow]="cover.value === maxSizeAllowed">&#43;
                      </div>
                    </div>
                  }
                  @if (coverTypes?.length ===0) {
                    <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                      <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                        (click)="changePartySize('prev')" [class.disabledArrow]="currentBookingSize === minSizeAllowed">&#45;
                      </div>
                      <div class="d-flex flex-column">
                        <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                        {{'partySize' | translate}}</div>
                        <div class="cursor dining-selected-data activity-description text-center select-date-text-decoration"
                          (click)="coverTypeSelect.open()">
                        {{currentBookingSize}}</div>
                        <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                          <mat-label>{{'partySize' | translate}}</mat-label>
                          <mat-select [(ngModel)]="currentBookingSize" #coverTypeSelect
                            (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                            @for (bookingSize of bookingSizeArray; track bookingSize) {
                              <mat-option [value]="bookingSize.id">
                                {{bookingSize.value}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                        (click)="changePartySize('next')" [class.disabledArrow]="currentBookingSize === maxSizeAllowed">&#43;
                      </div>
                    </div>
                  }
                  @if (activityService.selectedDining.WidgetCustomization?.ShowCommunalTableAvailabilityOption) {
                    <div
                      class="my-4 d-flex flex-nowrap">
                      <div>
                        <mat-checkbox class="chip-control__checkbox" [(ngModel)]="isCommunalTable"
                        (change)="checkSessionorSlotAvailability(false, true)"></mat-checkbox>
                      </div>
                      <div class="px-3 activity-description-bold">{{'communalTableAvailability' | translate}}</div>
                    </div>
                  }
                  @if (otherAvailableDays.length > 0) {
                    <div class="d-flex flex-wrap mb-3">
                      @if (!showAvailableDates) {
                        <div (click)="showAvailableDates=true"
                          class="cursor activity-description-bold activity-list-title disable-text-select">
                          {{'showAvailableDays' | translate}}
                        </div>
                      }
                      @if (showAvailableDates) {
                        @for (day of otherAvailableDays; track day) {
                          <div (click)="chooseAvailableDate(day)" matRipple
                            matRippleCentered="true" class="cursor dates-list d-flex flex-column m-2 justify-content-center"
                            [ngClass]="{'dates-list-selected': checkIfDateSelected(day.value) }">
                            <div class="text-center">{{day.value | localizeDate: 'DD'}}</div>
                            <div class="text-center">{{day.value | localizeDate: 'ddd'}}</div>
                          </div>
                        }
                      }
                    </div>
                  }
                  <div class="d-none d-lg-block">
                    <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
                    <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
                    <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
                  </div>
                </div>
                <div class="col-lg-8 col-md-12 mt-3 pt-1">
                  <div class="d-flex flex-wrap">
                    @if (seatingArea?.length > 0 && activityService?.displaySeatingArea) {
                      <mat-form-field class="px-2 col-sm-6 col-12" appearance="outline">
                        <!-- <mat-label>{{'seatingArea' | translate}}</mat-label> -->
                        <mat-select [(ngModel)]="selectedSeatingArea" name="seatingArea"
                          placeholder="{{'selectSeatingArea' | translate}}"
                          (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                          @for (seating of seatingArea; track seating) {
                            <mat-option [value]="seating.id">{{seating.value}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (seatingType?.length > 0 && activityService?.displaySeatingType) {
                      <mat-form-field class="px-2 col-sm-6 col-12" appearance="outline">
                        <!-- <mat-label>{{'seatingType' | translate}}</mat-label> -->
                        <mat-select [(ngModel)]="selectedSeatingType" name="seatingType"
                          placeholder="{{'selectSeatingType' | translate}}"
                          (ngModelChange)="checkSessionorSlotAvailability(false, true)">
                          @for (seatType of seatingType; track seatType) {
                            <mat-option [value]="seatType.id">{{seatType.value}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                  @if (activityService?.selectedDining?.MealTabs.length > 0) {
                    <div class="d-flex flex-column">
                      <div class="mb-2 px-2 activity-description-bolder text-uppercase">{{'mealPeriod' | translate}}</div>
                      <div class="mb-2 d-flex flex-wrap">
                        <mat-chip-listbox>
                          @for (option of activityService?.selectedDining?.MealTabs; track option) {
                            <mat-chip-option class="cursor"
                              [selected]="option.selected" [value]="option.Id"
                              (click)="spliceTimeArrayForTheSelectedMealTab(option)">
                              {{option.Name}}
                            </mat-chip-option>
                          }
                        </mat-chip-listbox>
                      </div>
                    </div>
                  }
                  <div class="d-flex flex-column">
                    <div class="mb-2 px-2 activity-description-bolder text-uppercase">{{'timeSlots' | translate}}</div>
                    <div class="d-flex flex-wrap mb-3">
                      @if (!isTimeDropList) {
                        @for (diningSlots of selectedDiningSlots; track diningSlots; let i = $index) {
                          <div class="p-2 col-md-2 col-sm-3 col-4 text-center" (click)="diningSlotChangeListners(diningSlots)">
                            <div class="p-2 dining-time-slot activity-description-bold"
                              [ngClass]="{'activity-time-slot-selected': diningSlots === checkedDiningLocalTime}">
                            {{diningSlots | localizeDate: 'LT'}}</div>
                          </div>
                        }
                      }
                    </div>
                    @if (selectedDiningSlots.length > 0 && isTimeDropList) {
                      <div class="d-flex justify-content-center">
                        <div class="dining-input-options py-4 mb-3 col-md-6 col-sm-7 col-12 d-flex justify-content-center">
                          <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                            (click)="changeTimeSlots('prev')"
                            [class.disabledArrow]="checkedDiningLocalTime === selectedDiningSlots[0]">&#60;
                          </div>
                          <div class="d-flex flex-column">
                            <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                              {{'time' |
                            translate}}</div>
                            <div class="cursor dining-selected-data activity-description text-center"
                              (click)="coverTypeSelect.open()">
                            {{checkedDiningLocalTime | localizeDate: 'LT'}}</div>
                            <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                              <mat-label>{{'time' | translate}}</mat-label>
                              <mat-select [(ngModel)]="checkedDiningLocalTime" #coverTypeSelect>
                                @for (timing of selectedDiningSlots; track timing; let i = $index) {
                                  <mat-option (click)="diningSlotChangeListners(timing)" [value]="timing"
                                    >
                                    {{timing | localizeDate: 'LT'}}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                            (click)="changeTimeSlots('next')"
                            [class.disabledArrow]="checkedDiningLocalTime === selectedDiningSlots[selectedDiningSlots.length - 1]">
                          &#62;</div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="d-block d-lg-none">
                    <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
                    <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
                    <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
                  </div>
                  @if (!activityService.loaderRunning && selectedDiningSlots?.length === 0) {
                    <div
                      class="no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
                      {{'noslots' | translate}}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (activityService.isNonDining) {
            <div class="row">
              @if (bShowLocation) {
                <div class="col-12 mt-4 d-flex flex-wrap non-dining-filters-top align-items-center">
                  <div class="booking-type-field"><ng-container *ngTemplateOutlet="bookingTypeFilter"></ng-container></div>
                  <div class="activity-field"><ng-container *ngTemplateOutlet="activityFilter"></ng-container></div>
                  <div class="row mx-0">
                    <div class="select-date col-12">
                      <label>{{'selectDate' | translate}}</label>
                    </div>
                    <div class="d-flex flex-column non-dining-child-div-filters-top" id="selected-date-location-screen">
                      <div class="d-flex flex-row selectable" [ngClass]="{'disable-date' : disableDatePicker}">
                        <div class="cursor dining-selected-data non-dining-selected-date"
                          (click)="slotEditngbPopOver?.close();frompicker.open()">
                          <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                            <span class="material-symbols-outlined">
                              calendar_today
                            </span>
                          </mat-icon>
                          {{currentFromDate | localizeDate : 'Do MMMM, ddd'}}
                          <mat-form-field appearance="outline" style="width:30px;height:1px;visibility: hidden;">
                            <mat-label>{{'selectDate' | translate}}</mat-label>
                            <input matInput placeholder="{{'selectDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : nonDiningMaxDate"
                              (dateChange)="changeFromDate();checkNonDiningSessionorSlotAvailability(false, true, false, true)"
                              [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
                              [matDatepickerFilter]="showParticularDays" [disabled]="disableDatePicker">
                              <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
                              </mat-datepicker-toggle>
                              <mat-datepicker #frompicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                    @if (activityService.displayLocationType === locationViewTypes.None && selectedSeatingType) {
                      <mat-divider [vertical]="true"></mat-divider>
                      <div class="d-flex flex-row non-dining-child-div-filters-location">
                        <div class="cursor dining-selected-data non-dining-selected-date selected-location-top-bar">
                          <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                            <span class="material-symbols-outlined">
                              push_pin
                            </span>
                          </mat-icon>
                          <div>
                            {{seatingTypeNames[selectedSeatingType]}}
                            @if (rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]) {
                              <div class="selected-location-price-top-bar" placement="bottom" [ngbPopover]="guestPriceSummaryByTypePopupContent">
                                {{'Price' | translate}}: ({{activityService.selectedNonDining.OperationCurrency}}{{(rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]?.Total !=='' ?
                                rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]?.Total : 0) | currencyDecimalFormatter}})
                              </div>
                            }
                            <ng-template #guestPriceSummaryByTypePopupContent>
                              <app-activites-guest-price-summary [priceDetail]="rateplanSupportService.seatingTypePriceDetail[selectedSeatingType]" [currency]="activityService.selectedNonDining.OperationCurrency"></app-activites-guest-price-summary>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    }
                    @if (activityService.displayLocationType !== locationViewTypes.None && selectedNonDiningSlotsDisplayText) {
                      <mat-divider [vertical]="true"></mat-divider>
                      <div class="row mx-0">
                        <div class="select-time col-12">
                          <label>{{'selectTimeSlot' | translate}}</label>
                        </div>
                        <div class="d-flex flex-column non-dining-child-div-filters-top" id="selected-slot-display-text">
                          <div class="d-flex flex-row selectable" [ngClass]="{'disable-date' : disableDatePicker}">
                            <div class="cursor dining-selected-data non-dining-selected-date"
                              (click)="frompicker.close();checkSlotReloadRequired()" [ngbPopover]="EditSlotContainer"
                              placement="bottom right top left" [autoClose]="false" #slotEditngbPopOver="ngbPopover">
                              <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                                <span class="material-symbols-outlined">
                                  schedule
                                </span>
                              </mat-icon>
                              {{selectedNonDiningSlotsDisplayText}}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (activityService.displayLocationType !== locationViewTypes.None && activityService?.selectedNonDiningLocation?.length) {
                      <mat-divider [vertical]="true"></mat-divider>
                      <div class="d-flex flex-column non-dining-child-div-filters-top" id="selected-slot-display-text">
                        <div class="d-flex flex-row non-dining-child-div-filters-location">
                          <div class="cursor dining-selected-data non-dining-selected-date selected-location-top-bar">
                            <mat-icon class="slot-edit-icon cursor" aria-hidden="false" aria-label="edit">
                              <span class="material-symbols-outlined">
                                push_pin
                              </span>
                            </mat-icon>
                            @for (location of activityService?.selectedNonDiningLocation; track location) {
                              <div>
                                {{location.Name}}
                                @if (location.PriceDetail) {
                                  <div class="selected-location-price-top-bar" placement="bottom" [ngbPopover]="guestPriceSummaryPopupContent">
                                    {{'TotalPriceTopBarText' | translate}}: ({{activityService.selectedNonDining.OperationCurrency}}{{(location.PriceDetail?.Total !=='' ?
                                    location.PriceDetail?.Total : 0) | currencyDecimalFormatter}})
                                  </div>
                                }
                              </div>
                              <ng-template #guestPriceSummaryPopupContent>
                                <app-activites-guest-price-summary [priceDetail]="location.PriceDetail" [currency]="activityService.selectedNonDining.OperationCurrency"></app-activites-guest-price-summary>
                              </ng-template>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    @if (activityService.displayLocationType == locationViewTypes.LayoutView) {
                      <div class="px-2 map-legend text-uppercase"
                        >
                        <span class="ss-map-legend-values-conatainer">
                          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="legend menu">
                            <mat-icon class="legend-menu-icon">category</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item class="legend-field">
                              <mat-icon class="legend-icon sold">block</mat-icon>
                              <!-- <span >&#8416;</span> -->
                              <span>{{'Sold' | translate}}</span>
                            </button>
                            <button mat-menu-item class="legend-field">
                              <mat-icon class="legend-icon selected">check</mat-icon>
                              <!-- <span class="legend-icon selected">&#10003;</span> -->
                              <span>{{'Selected' | translate}}</span>
                            </button>
                          </mat-menu>
                        </span>
                        <span class="bs-map-legend-values-conatainer">
                          <!-- (click)="viewChange()" -->
                          <div class="legend-field"><span class="legend-icon sold">&#8416;</span> {{'Sold' | translate}}</div>
                          <div class="legend-field"><span class="legend-icon selected">&#10003;</span> {{'Selected' | translate}}
                        </div>
                      </span>
                    </div>
                  }
                </div>
              }
              <div class="col-12 mt-4 d-flex flex-wrap">
                @if (bShowLocation) {
                  <div class="col-lg-3 col-md-12 d-flex flex-column border-right non-dining-location-filters"
                    id="non-dining-filters-left-side">
                    <ng-container>
                      <size-mapping [coverTypes]="coverTypes" [bookingTypes]="bookingTypes" [minSize]="minSizeAllowed" [maxSize]="maxSizeAllowed" [(size)]="sizeMapping" (sizeChange)="bookingSizeChange()" [dataCovers]="selectedActivityData?.CoverTypeQuantities || []" [dataSize]="currentBookingSize" [isEdit]="isEdit"></size-mapping>
                    </ng-container>
                    <!-- <ng-container *ngTemplateOutlet="nonDiningPartySizeField"></ng-container>
                    <ng-container *ngTemplateOutlet="nonDiningCoverAndBookingTypeFields"></ng-container> -->
                    @if (seatingArea?.length > 0 && activityService?.displaySeatingArea) {
                      <div class="d-flex flex-column non-dining-child-div-filters-top" id="seating-area-container">
                        <div class="d-flex flex-column" id="full-width">
                          <!-- (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)" -->
                          <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields"
                            appearance="outline">
                            <mat-label>{{'seatingArea' | translate}}</mat-label>
                            <mat-select [(ngModel)]="selectedSeatingArea" name="seatingArea"
                              placeholder="{{'selectSeatingArea' | translate}}"
                              (ngModelChange)="seatingArea_TypeFieldChangeHandler(selectedSeatingArea, false, true)">
                              <mat-option [value]="null">{{'NA' | translate}}</mat-option>
                              @for (seating of seatingArea; track seating) {
                                <mat-option [value]="seating.id">{{seating.value}}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if (activityService?.displaySeatingType) {
                      <div class="d-flex flex-column non-dining-child-div-filters-top" id="seating-type-container"
                        >
                        <div class="d-flex flex-column" id="full-width">
                          <p>{{'seatingType' | translate}}</p>
                          @for (seatType of seatingType; track seatType) {
                            @if (!seatType.isHide) {
                              <div class="seating-type-card cursor-pointer"
                                (click)="seatingArea_TypeFieldChangeHandler(seatType, true, true)"
                                [ngClass]="{'activity-time-slot-selected': selectedSeatingType == seatType.id}">
                                <div class="seating-type-color" [style.background-color]="seatType.color">
                                </div>
                                <div class="seating-type-label">
                                  {{ seatType.value }}
                                </div>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (!bShowLocation) {
                  <div class="col-lg-4 col-md-12 d-flex flex-column">
                    <ng-container  *ngTemplateOutlet="bookingTypeFilter"></ng-container>
                    <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                      <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                        (click)="changeNonDiningDate('prev')"
                      [class.disabledArrow]="currentFromDate <= activityService.currentDateTime">&#60;</div>
                      <div class="d-flex flex-column">
                        <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">{{'date' |
                        translate}}</div>
                        <div class="cursor dining-selected-data activity-description text-center" (click)="frompicker.open()">
                        {{currentFromDate | localizeDate : 'DD MMMM, ddd'}}</div>
                        <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                          <mat-label>{{'selectDate' | translate}}</mat-label>
                          <input matInput placeholder="{{'selectDate' | translate}}" readonly [max]="bookingTypeMaxDate ? bookingTypeMaxDate : nonDiningMaxDate"
                            (dateChange)="changeFromDate();checkNonDiningSessionorSlotAvailability(false, true)"
                            [min]="bookingTypeMinDate ? bookingTypeMinDate : activityService.currentDateTime" [matDatepicker]="frompicker" [(ngModel)]="currentFromDate"
                            [matDatepickerFilter]="showParticularDays" [disabled]="disableDatePicker">
                            <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="frompicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker #frompicker></mat-datepicker>
                          </mat-form-field>
                        </div>
                        <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                          (click)="changeNonDiningDate('next')" [class.disabledArrow]="currentFromDate >= nonDiningMaxDate">&#62;
                        </div>
                    </div>
                      <!-- <ng-container @if (coverTypes?.length) {
                      <ng-container @for (cover of coverTypes; track cover; let i = $index) {
                        <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                          <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select" (click)="changeNonDiningCoverTypeSize('prev', i)"
                          [class.disabledArrow]="cover.value === 0">&#45;</div>
                          <div class="d-flex flex-column">
                            <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">{{cover.name}}</div>
                            <div class="cursor dining-selected-data activity-description text-center" (click)="coverTypeSelect.open()">
                            {{cover.value}}</div>
                            <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                              <mat-label>{{cover.name}}</mat-label>
                              <mat-select [(ngModel)]="cover.value" #coverTypeSelect
                                (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                                <mat-option [value]="0">{{'0' | translate}}</mat-option>
                                <mat-option [value]="bookingSize.id" @for (bookingSize of bookingSizeArray; track bookingSize) {>
                                  {{bookingSize.value}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select" (click)="changeNonDiningCoverTypeSize('next', i)"
                          [class.disabledArrow]="cover.value === maxSizeAllowed">&#43;</div>
                        </div>
                      </ng-container>
                    </ng-container> } -->
                    <ng-container>
                      <size-mapping [coverTypes]="coverTypes" [bookingTypes]="bookingTypes" [minSize]="minSizeAllowed" [maxSize]="maxSizeAllowed" [(size)]="sizeMapping" (sizeChange)="bookingSizeChange()" [dataCovers]="selectedActivityData?.CoverTypeQuantities || []" [dataSize]="currentBookingSize" [isEdit]="isEdit"></size-mapping>
                    </ng-container>
                    <!-- <ng-container *ngTemplateOutlet="nonDiningCoverAndBookingTypeFields"></ng-container> -->
                    <!-- <ng-container @if (coverTypes?.length ===0) {
                    <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                      <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                      (click)="changeNonDiningPartySize('prev')" [class.disabledArrow]="currentBookingSize === 0">&#45;</div>
                      <div class="d-flex flex-column">
                        <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                        {{'partySize' | translate}}</div>
                        <div class="cursor dining-selected-data activity-description text-center"
                          (click)="coverTypeSelect.open()">
                        {{currentBookingSize}}</div>
                        <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                          <mat-label>{{'partySize' | translate}}</mat-label>
                          <mat-select [(ngModel)]="currentBookingSize" #coverTypeSelect
                            (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                            <mat-option [value]="0">{{'0' | translate}}</mat-option>
                            <mat-option [value]="bookingSize.id" @for (bookingSize of bookingSizeArray; track bookingSize) {>
                              {{bookingSize.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                        (click)="changeNonDiningPartySize('next')"
                      [class.disabledArrow]="currentBookingSize === maxSizeAllowed">&#43;</div>
                    </div>
                    </ng-container> } -->
                  <ng-container *ngTemplateOutlet="nonDiningDurationField"></ng-container>
                  @if (seatingArea?.length > 0 && activityService?.displaySeatingArea) {
                    <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                      <div class="d-flex flex-column" id="full-width">
                        <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                          {{'seatingArea' |
                        translate}}</div>
                        <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields" appearance="fill">
                          <!-- <mat-label>{{'seatingArea' | translate}}</mat-label> -->
                          <mat-select [(ngModel)]="selectedSeatingArea" name="seatingArea"
                            placeholder="{{'selectSeatingArea' | translate}}"
                            (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                            <mat-option [value]="null">{{'NA' | translate}}</mat-option>
                            @for (seating of seatingArea; track seating) {
                              <mat-option [value]="seating.id">{{seating.value}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  }
                  @if (seatingType?.length > 0 && activityService?.displaySeatingType) {
                    <div class="dining-input-options p-2 mb-3 d-flex justify-content-center">
                      <div class="d-flex flex-column" id="full-width">
                        <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">
                          {{'seatingType' |
                        translate}}</div>
                        <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields" appearance="fill">
                          <!-- <mat-label>{{'seatingType' | translate}}</mat-label> -->
                          <mat-select [(ngModel)]="selectedSeatingType" name="seatingType"
                            placeholder="{{'selectSeatingType' | translate}}"
                            (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)">
                            <mat-option [value]="null">{{'NA' | translate}}</mat-option>
                            @for (seatType of seatingType; track seatType) {
                              <mat-option [value]="seatType.id">{{seatType.value}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  }
                  @if (activityService.selectedNonDining.WidgetCustomization?.ShowCommunalTableAvailabilityOption) {
                    <div
                      class="my-4 d-flex flex-nowrap">
                      <div>
                        <mat-checkbox class="chip-control__checkbox" [(ngModel)]="isCommunalTable"
                        (change)="checkNonDiningSessionorSlotAvailability(false, true)"></mat-checkbox>
                      </div>
                      <div class="px-3 activity-description-bold">{{'communalTableAvailability' | translate}}</div>
                    </div>
                  }
                  @if (otherAvailableDays.length > 0) {
                    <div class="d-flex flex-wrap mb-3">
                      @if (!showAvailableDates) {
                        <div (click)="showAvailableDates=true"
                          class="cursor activity-description-bold activity-list-title disable-text-select">
                          {{'showAvailableDays' | translate}}
                        </div>
                      }
                      @if (showAvailableDates) {
                        @for (day of otherAvailableDays; track day) {
                          <div (click)="chooseAvailableDate(day)" matRipple
                            matRippleCentered="true" class="cursor dates-list d-flex flex-column m-2 justify-content-center"
                            [ngClass]="{'dates-list-selected': checkIfDateSelected(day.value) }">
                            <div class="text-center">{{day.value | localizeDate: 'DD'}}</div>
                            <div class="text-center">{{day.value | localizeDate: 'ddd'}}</div>
                          </div>
                        }
                      }
                    </div>
                  }
                  <div class="d-none d-lg-block">
                    <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
                    <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
                    <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
                  </div>
                </div>
              }
              @if (activityService.displayLocationType == locationViewTypes.None) {
                <div class="col-lg-8 col-md-12">
                  @if (isMultiSlotSelection) {
                    <ng-container *ngTemplateOutlet="nonDiningDurationField"></ng-container>
                  }
                  <ng-container *ngTemplateOutlet="nonDiningTimeSlots"></ng-container>
                </div>
              }
              @if (selectedNonDiningSlots?.length && matchedContinousSlots?.length) {
                @if (floorPlan && activityService.displayLocationType == locationViewTypes.LayoutView) {
                  <div
                    class="col-lg-9 col-md-12 pd-r0">
                    <activities-layout [floorPlan]="floorPlan" [currentBookingSize]="overAllBookingSize"
                      [seatingTypeList]="seatingTypesMasterList" [updateIndicator]="updateIndicator"
                      [selectedSeatingType]="selectedSeatingType"
                      (locationSelection)="locationSelectionInMapHandler($event)"
                      [currentFromDate]="currentFromDate" [matchedContinousSlots]="matchedContinousSlots" [duration]="durationControl.value" [sizeMapping]="sizeMapping"
                    [restaurantId]="route.snapshot.params.restaurantId"></activities-layout>
                  </div>
                }
                @if (bShowLocation && activityService.displayLocationType == locationViewTypes.ListView) {
                  <div class="col-lg-9 col-md-12 pd-r0 location-list-parent-conatiner"
                    >
                    <div>
                      @for (location of activityService?.selectedNonDiningLocation; track location) {
                        @if (location.Price) {
                          <div class="selected-location-price-top-bar" placement="bottom" [ngbPopover]="locationGuestPriceSummaryPopupContent">
                            {{'Price' | translate}}: ({{activityService.selectedNonDining.OperationCurrency}}{{(location.PriceDetail?.Total !=='' ?
                            location.PriceDetail?.Total : 0) | currencyDecimalFormatter}})
                          </div>
                        }
                        <ng-template #locationGuestPriceSummaryPopupContent>
                          <app-activites-guest-price-summary [priceDetail]="location.PriceDetail" [currency]="activityService.selectedNonDining.OperationCurrency"></app-activites-guest-price-summary>
                        </ng-template>
                      }
                    </div>
                    <div class="d-flex flex-column">
                      <div class="mb-2 px-2 activity-description-bolder text-uppercase location-list-header">{{'Locations' |
                      translate}}</div>
                      <div class="d-flex flex-wrap mb-3 location-list-container">
                        @if (!isTimeDropList) {
                          @for (table of filteredTableList; track table; let i = $index) {
                            <div class="p-2 col-md-4 col-sm-5 col-6 text-center" (click)="locationViewSelectionEventHandler(table)">
                              <div class="p-2 dining-time-slot location-card activity-description-bold"
                                [style.border-left-color]="table.seatingTypeColor ? table.seatingTypeColor : 'none'"
                                [ngClass]="{'activity-time-slot-selected': table.isSelected}">
                                @if (table.isSelected) {
                                  <ng-container *ngTemplateOutlet="selectedIcon"></ng-container>
                                }
                                {{table.Name}}
                                @if (activityService.validateLocationSize) {
                                  <div class="location-size-container">
                                    {{'Min'}}: {{table.MinPartySize}} {{'Max'}}: {{table.MaxPartySize}}
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                    <div class="d-block d-lg-none">
                      <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
                      <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
                      <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
                    </div>
                    @if (!activityService.loaderRunning && filteredTableList?.length === 0) {
                      <div
                        class="no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
                        {{'noLocations' | translate}}
                      </div>
                    }
                  </div>
                }
              }
              @if (selectedNonDiningSlots?.length && !matchedContinousSlots?.length) {
                <div
                  class="col-lg-9 no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
                  {{'PleaseSelectTimeSlotsToShowTheTablesOrSeating' | translate}}
                </div>
              }
              @if (!activityService.loaderRunning && !selectedNonDiningSlots?.length && !matchedContinousSlots?.length) {
                <div
                  class="col-lg-9 no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
                  {{'unavailableForSelectionInfo' | translate}}
                </div>
              }
            </div>
          </div>
        }
        <div class="confirm-button-section col-12 mt-5">
          @if (activityService.isNonDining && (!bShowLocation || activityService.displayLocationType == locationViewTypes.None) ) {
            <div class="d-flex flex-wrap justify-content-around"
              >
              <button mat-button type="button"
                class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
                [disabled]="!validGroupSize || !checkedItem || !checkedNonDiningLocalTime || disableDatePicker || !validMinMaxDuration || disableContinue" (click)="navigateGuestData()">
                <!-- (click)="showHideLocationEventHandler()" -->
                {{'continue' | translate}}
              </button>
            </div>
          }
          @if (activityService.isNonDining && bShowLocation && activityService.displayLocationType !== locationViewTypes.None) {
            <div class="d-flex flex-wrap justify-content-around"
              >
              <button mat-button type="button"
                class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
                [disabled]="!validGroupSize || !checkedItem || activityService.nonDiningTotalSeatsSelected != overAllBookingSize || disableDatePicker || !validMinMaxDuration || disableContinue"
                (click)="navigateGuestData()">
                {{'continue' | translate}}
              </button>
            </div>
          }
        </div>
        @if (!activityService.isNonDining) {
          <div class="confirm-button-section col-12 mt-5">
            <div class="d-flex flex-wrap justify-content-around">
              <button mat-button type="button"
                class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
                [disabled]="!validGroupSize || !checkedItem || disableContinue" (click)="navigateGuestData()">
                {{'continue' | translate}}
              </button>
            </div>
          </div>
        }
      </div>
    }
    @if (activityService.showGuestFields) {
      <div class="container">
        <div class="confirm-button-section col-12 mt-5">
          <div class="d-flex flex-wrap justify-content-around">
            <button mat-button type="button" [disabled]="!guestContactValidation || finishReservationClicked "
              class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
              (click)="proceedMultiBooking(true)">
              {{'finishReservation' | translate}}
            </button>
            @if (!isEdit) {
              <button mat-button type="button" (click)="addToCart()" [disabled]="!guestContactValidation "
                class="my-3 activity-buttons activity-confirm-buttons text-center text-center text-uppercase">
                {{'AddToCart' | translate}}
              </button>
            }
          </div>
        </div>
        <div class="confirm-button-section col-12 mt-5">
          <div class="d-flex flex-wrap justify-content-around">
            <button mat-button type="button"
              class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase"
              (click)="backToSlotSelect()">
              {{'Back' | translate}}
            </button>
          </div>
        </div>
      </div>
    }
    <ng-template #notesDisplayContent>
      <!-- Enable when Notes is added for Activities -->
      <!-- <ng-container @for (notes of notesOptions; track notes) {
      <div @if (notes.text) { class="activity-description-bolder text-uppercase">
        {{notes.text}}
      </div>
      <div class="d-flex flex-row">
        <mat-chip-list selectable multiple>
          <mat-chip class="cursor" #c="matChip" @for (option of notes.checkBoxOptions; track option) { [selected]="option.selected"
            [value]="option.value" (click)="toggleSelection(c, option)">
            <mat-icon class="chip-check-icon" @if (c.selected) {>check</mat-icon>
            {{option.value}}
          </mat-chip>
        </mat-chip-list>
      </div>
      <div @if (notes.commentsBox?.id && !activityService.isDining) { class="pt-2" style="font-size: 13px;color: #585252">Note: Please specify the party that you are joining</div>
      <div @if (notes.commentsBox?.id) { class="pt-2 d-flex flex-row">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Leave a comment</mat-label>
          <textarea [(ngModel)]="notes.commentsBox.value" matInput placeholder="Add your comments here"></textarea>
        </mat-form-field>
      </div>
    </ng-container> -->
  </ng-template>

  <ng-template #promoCodeContent>
    @if (activityService.selectedDining.WidgetCustomization?.DisplayPromoCode) {
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{activityService.selectedDining.WidgetCustomization?.PromoCodeLabel ?
          activityService.selectedDining.WidgetCustomization?.PromoCodeLabel : ('promoCode' | translate)}}</mat-label>
          <input matInput type="text"
            placeholder="{{activityService.selectedDining.WidgetCustomization?.PromoCodeLabel ? activityService.selectedDining.WidgetCustomization?.PromoCodeLabel : ('promoCode' | translate)}}"
            [(ngModel)]="promoCodeDetail" name="promoCode" />
          </mat-form-field>
        </div>
      }
    </ng-template>

    <ng-template #marketOptInContent>
      @if (activityService.selectedDining.MarketingFlagEnabled) {
        <div class="my-4 d-flex flex-nowrap">
          <div>
            <mat-checkbox class="chip-control__checkbox" [(ngModel)]="marketingFlag"></mat-checkbox>
          </div>
          <div class="px-3 activity-description-bold">{{activityService.selectedDining.MarketingFlagDescription}}</div>
        </div>
      }
    </ng-template>



    <!-- (click) = "$event.stopPropagation()" -->
    <ng-template #EditSlotContainer>
      <div class="edit-slot-content">
        <button class="close-icon-button" aria-label="close" (click)="closeSlotEditPopOver()">
          <mat-icon>close</mat-icon>
        </button>
        @if (isMultiSlotSelection) {
          <div class="non-dining-duration-popover-field-container">
            <ng-container *ngTemplateOutlet="nonDiningDurationField"></ng-container>
          </div>
        }
        <div class="col-lg-12 col-md-12 non-dining-duration-popover-slot-container">
          <ng-container *ngTemplateOutlet="nonDiningTimeSlots"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #nonDiningDurationField>
      <div class="dining-input-options p-2 mb-3 d-flex justify-content-center"
        [ngClass]="{ 'wd-40 auto-assignment-duration-field': activityService.displayLocationType == locationViewTypes.None }">
        <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
          (click)="changeNonDiningDuration('prev')" [class.disabledArrow]="durationControl.value <= TimeSlotUnitInMinutes">
        &#45;</div>
        <div class="d-flex flex-column">
          @if (!bShowLocation || activityService.displayLocationType == locationViewTypes.None) {
            <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center"
              >{{'Duration' |
            translate}}</div>
          }
          <div class="cursor dining-selected-data activity-description text-center">
            <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="input-border-bottom seating-fields"
              appearance="fill">
              @if (bShowLocation && activityService.displayLocationType !== locationViewTypes.None) {
                <mat-label
                  >{{'Duration' |
                translate}}</mat-label>
              }
              <input type="number" class="duration-input-field" matInput [formControl]="durationControl"
                [matAutocomplete]="auto" [durationList]="durationList" appDurationValue>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  @for (option of filteredDurationOptions | async; track option) {
                    <mat-option [value]="option"
                      (click)="setDurationControlValue(option);">
                      {{option.displayName}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
            (click)="changeNonDiningDuration('next')"
          [class.disabledArrow]="durationControl.value >= durationList[durationList.length-1]">&#43;</div>
        </div>
      </ng-template>

      <ng-template #nonDiningTimeSlots>
        <div class="d-flex flex-column">
          <div class="mb-2 px-2 activity-description-bolder text-uppercase slot-list-header">{{'timeSlots' | translate}}</div>
          <div class="d-flex flex-wrap mb-3 slot-list-container">
            @if (!isTimeDropList) {
              @for (nonDiningSlots of selectedNonDiningSlots; track nonDiningSlots; let i = $index) {
                <div class="p-2 col-md-2 col-sm-3 col-4 text-center" (click)="nonDiningSlotChangeListners(nonDiningSlots)">
                  <div class="p-2 dining-time-slot activity-description-bold"
                    [ngClass]="{'activity-time-slot-selected': highlightSelectedNonDiningSlots(nonDiningSlots)}">
                  {{nonDiningSlots | localizeDate: 'LT'}}</div>
                </div>
              }
            }
          </div>
          @if (selectedNonDiningSlots.length > 0 && isTimeDropList) {
            <div class="d-flex justify-content-center">
              <div class="dining-input-options py-4 mb-3 col-md-6 col-sm-7 col-12 d-flex justify-content-center">
                <div class="px-3 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                  (click)="changeNonDiningTimeSlots('prev')"
                  [class.disabledArrow]="checkedNonDiningLocalTime === selectedNonDiningSlots[0]">&#60;
                </div>
                <div class="d-flex flex-column">
                  <div class="dining-input-placeholder activity-description-bolder text-uppercase text-center">{{'time' |
                  translate}}</div>
                  <div class="cursor dining-selected-data activity-description text-center" (click)="coverTypeSelect.open()">
                  {{checkedNonDiningLocalTime | localizeDate: 'LT'}}</div>
                  <mat-form-field appearance="outline" style="width:160px;height:1px;visibility: hidden;">
                    <mat-label>{{'time' | translate}}</mat-label>
                    <mat-select [(ngModel)]="checkedNonDiningLocalTime" #coverTypeSelect>
                      @for (timing of selectedNonDiningSlots; track timing; let i = $index) {
                        <mat-option (click)="nonDiningSlotChangeListners(timing)" [value]="timing"
                          >
                          {{timing | localizeDate: 'LT'}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="px-3 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                  (click)="changeNonDiningTimeSlots('next')"
                  [class.disabledArrow]="checkedNonDiningLocalTime === selectedNonDiningSlots[selectedNonDiningSlots.length - 1]">
                &#62;</div>
              </div>
            </div>
          }
        </div>
        <div class="d-block d-lg-none">
          <!-- <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
          <ng-container *ngTemplateOutlet="promoCodeContent"></ng-container>
          <ng-container *ngTemplateOutlet="marketOptInContent"></ng-container> -->
        </div>
        @if (!activityService.loaderRunning && selectedNonDiningSlots?.length === 0) {
          <div
            class="no-slots-message dining-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
            {{'noslots' | translate}}
          </div>
        }
      </ng-template>


      <ng-template #selectedIcon>
        <mat-icon class="legend-icon selected">check</mat-icon>
      </ng-template>

      <ng-template #nonDiningPartySizeField>

        @if (!coverTypes?.length && !bookingTypes?.length) {
          <div
            class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
            <div class="wd-60 type-field-headers activity-description-bolder">{{ 'partySize' | translate }}</div>
            <div class="wd-40">
              <div
                class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
              (click)="changeNonDiningPartySize('prev')" [class.disabledArrow]="currentBookingSize === 0">&#45;</div>
              <div class="wd-30 d-flex">
                <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">
                  <input type="number" [(ngModel)]="currentBookingSize"
                    (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true);updateSlotReloadValue()" matInput
                    [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                      <mat-option [value]=0>{{'0' | translate}}</mat-option>
                      @for (bookingSize of bookingSizeArray; track bookingSize) {
                        <mat-option [value]="bookingSize.id">
                          {{bookingSize.value}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div
                  class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                  (click)="changeNonDiningPartySize('next')" [class.disabledArrow]="currentBookingSize === maxSizeAllowed">&#43;
                </div>
              </div>
            </div>
          }

        </ng-template>


        <ng-template #nonDiningCoverAndBookingTypeFields>

          @if (coverTypes?.length || bookingTypes?.length) {
            @if (bookingTypes?.length) {
              <h4 class="cover-booking-types-titles">{{ 'BookingTypes' | translate }}</h4>
            }
            @for (bookType of bookingTypes; track bookType; let i = $index) {
              <div
                class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
                <div class="wd-60 type-field-headers">{{bookType.name}}</div>
                <div class="wd-40">
                  <div
                    class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                  (click)="changeNonDiningBookingTypeSize('prev', i)" [class.disabledArrow]="bookType.value === 0">&#45;</div>
                  <div class="wd-30 d-flex">
                    <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">
                      <input type="number" [(ngModel)]="bookType.value" name="bookType_{{i}}"
                        (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)" matInput
                        [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                          <mat-option [value]=0>{{'0' | translate}}</mat-option>
                          @for (bookingSize of bookingSizeArray; track bookingSize) {
                            <mat-option [value]="bookingSize.id">
                              {{bookingSize.value}}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                    <div
                      class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                      (click)="changeNonDiningBookingTypeSize('next', i)"
                    [class.disabledArrow]="bookType.value === maxSizeAllowed">&#43;</div>
                  </div>
                </div>
              }
              @if (coverTypes?.length) {
                <h4 class="cover-booking-types-titles">{{ 'CoverTypes' | translate }}</h4>
              }
              @for (cover of coverTypes; track cover; let i = $index) {
                <div
                  class="dining-input-options type-input-field-options p-2 mb-3 d-flex justify-content-center booking-type-fields">
                  <div class="wd-60 type-field-headers">{{cover.Name || cover.name}}</div>
                  <div class="wd-40">
                    <div
                      class="type-field-minus-icon wd-35 d-flex align-items-center cursor dining-select-prev-date disable-text-select"
                    (click)="changeNonDiningCoverTypeSize('prev', i)" [class.disabledArrow]="cover.value === 0">&#45;</div>
                    <div class="wd-30 d-flex">
                      <mat-form-field class="input-border-bottom seating-fields text-align-center" id="full-width">
                        <!-- <mat-label>{{cover.Name}}</mat-label> -->
                        <input type="number" [(ngModel)]="cover.value" name="cover_{{i}}"
                          (ngModelChange)="checkNonDiningSessionorSlotAvailability(false, true)" matInput
                          [matAutocomplete]="auto">
                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option [value]=0>{{'0' | translate}}</mat-option>
                            @for (bookingSize of bookingSizeArray; track bookingSize) {
                              <mat-option [value]="bookingSize.id">
                                {{bookingSize.value}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                      <div
                        class="type-field-plus-icon wd-35 d-flex align-items-center cursor dining-select-next-date disable-text-select"
                        (click)="changeNonDiningCoverTypeSize('next', i)" [class.disabledArrow]="cover.value === maxSizeAllowed">
                      &#43;</div>
                    </div>
                  </div>
                }
              }

            </ng-template>

            <ng-template #bookingTypeFilter>
              @if (bookingTypeList?.length) {
                <div>
                  <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields"
                    appearance="outline">
                    <mat-label>{{'selectBookingType' | translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedBookingTypeId" name="bookingType"
                      placeholder="{{'selectSeatingArea' | translate}}"
                      (ngModelChange)="bookingTypeChangeHandler()">
                      @for (type of bookingTypeList; track type) {
                        <mat-option [value]="type.id">{{type.value}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
            
                <!-- Form wrapper for Hotel Guest and Member booking types -->
                <!-- Fields for Hotel Guest and Member booking types -->
                @if (selectedBookingType !== BookingGuestType.Others) {
                <!-- Last Name Field (for both Hotel Guest and Member) -->
                <div>
                  <mat-form-field class="seating-fields" appearance="outline">
                    <mat-label>{{'lastName' | translate}}</mat-label>
                    <input matInput type="text" [(ngModel)]="StayGuestLastName" (ngModelChange)="StayGuestLastNameChangeHandler($event)"
                      required name="StayGuestLastName">
                  </mat-form-field>
                </div>
                
                <!-- Arrival Date Field (Hotel Guest only) -->
                @if (selectedBookingType === BookingGuestType.HotelGuest) {
                    <div>
                      <mat-form-field class="seating-fields" appearance="outline">
                        <mat-label>{{'staystartDate' | translate}}</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" required [(ngModel)]="stayGuestStartDate"
                          (ngModelChange)="stayGuestStartDateChangeHandler($event)" name="stayGuestStartDate">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  }
            
                  <!-- Confirmation/Membership Number Field -->
                  <div>
                    <mat-form-field class="seating-fields w-100" appearance="outline">
                     <mat-label>{{bookingTypePlaceholder}}</mat-label>
                      <input matInput type="text" 
                         [(ngModel)]="confirmationNumber" (ngModelChange)="confirmationNumberChangeHandler($event)"
                         required
                        name="confirmationNumber"
                        >
                    </mat-form-field>
                  </div>
                  
                  <!-- Search Button - Always visible, disabled when form invalid -->
                  <div class="d-flex justify-content-center mb-4">
                    <button mat-button
                      type="button" 
                      (click)="applyBookingType()" 
                      [disabled]="disableStaySearch"
                      class="my-3 activity-buttons activity-confirm-buttons text-center text-uppercase">
                      {{'search' | translate}}
                    </button>
                  </div>
                }
              }
            </ng-template>

            <ng-template #activityFilter>
              @if (activityTypeList?.length && !activityService?.toListOpenActitivitiesList && !isEdit) {
                <div >
                  <mat-form-field class="px-2 col-sm-6 col-12" id="full-width" class="seating-fields"
                    appearance="outline">
                    <mat-label>{{'ActivityName' | translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedActivity" name="activityId"
                      placeholder="{{'selectedActivityName' | translate}}"
                      (ngModelChange)="activityChangeHandler()">
                      @for (type of activityTypeList; track type) {
                        <mat-option [value]="type.id">{{type.value}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </ng-template>